<p-toast></p-toast>
<div>
    <p-card styleClass="p-card-shadow">
        <div class="card grid">
            <div class="col-12 md:col-3">
            </div>
            <div class="col-12 md:col-6">
                <div class="flex justify-content-between flex-wrap">
                    <div class="flex align-items-center justify-content-center col-12 md:col-6">
                        <p-dropdown (onChange)="onApplicationTypeSelected($event)" [options]="dropDownList"
                            placeholder="{{'SELECT_APPLICATION_TYPE' | translate}}" optionLabel="type"
                            [(ngModel)]="applicationSelected" [disabled]="xslxToJsonData?.length > 0">
                        </p-dropdown>
                    </div>
                    <div class="flex align-items-center justify-content-center col-12 md:col-6">
                        <p-fileUpload [disabled]="!applicationSelected" accept=".xlsx" #fileUpload [customUpload]="true"
                            (uploadHandler)="onUpload($event, 'farmersPhotoPath', fileUpload)" name="myfile[]"
                            mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE' | translate}}" [auto]="true">
                        </p-fileUpload>
                        <button *ngIf="xslxToJsonData?.length" pButton pRipple type="button"
                            label="{{'VIEW_DOC' | translate}}" class="p-button-text" (click)="onOpenDialog()"></button>
                        <button *ngIf="xslxToJsonData?.length" pButton pRipple type="button" icon="pi pi-trash"
                            pTooltip="{{'DELETE_FILE' | translate}}"
                            class="p-button-rounded p-button-danger p-button-text" (click)="clearUpload()"></button>
                    </div>
                </div>
                <div class="mt-4 red" *ngIf="xslxToJsonData?.length">
                    ( {{'IN_TOTAL_THERE_ARE' | translate}} {{xslxToJsonData?.length}} {{'ROWS_IN_SELECTED_DOCUMENT' |
                    translate }} )
                </div>
                <div class="flex justify-content-center flex-wrap card-container mt-8">
                    <div class="flex align-items-center justify-content-center">
                        <button [disabled]="!applicationSelected" pButton pRipple label="{{'SUBMIT' | translate}}"
                            icon="pi pi-upload" class="p-button-help" (click)="submitApplication()"></button>
                    </div>
                </div>
            </div>
        </div>

    </p-card>
</div>


<p-dialog [(visible)]="showViewDocDialog" [modal]="true" [style]="{margin : '3rem', width: '100%', height: '80%'}"
    [maximizable]="true" [draggable]="false" [resizable]="true" (onHide)="onCloseDialog()">
    <p-table [columns]="cols" [value]="xslxToJsonData" responsiveLayout="scroll">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns">
                    {{col.header}}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td *ngFor="let col of columns">
                    {{rowData[col.field]}}
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>

<div *ngIf="responseDate.length > 0">
    <p-card styleClass="p-card-shadow mt-5">
        <div class="card dashboardTable">
            <!-- <p-toolbar styleClass="mb-4"> -->
                <!-- <ng-template pTemplate="left"> -->
                    <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                    <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
                <!-- </ng-template> -->
                <!-- <ng-template pTemplate="right"> -->
                    <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                    <!-- <button (click)="menu.toggle($event)" pButton pRipple label="Export" icon="pi pi-upload"
                        class="p-button-help"></button>

                    <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                    <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}"
                        icon="pi pi-refresh" class="p-button-info ml-3"></button> -->
                <!-- </ng-template> -->
            <!-- </p-toolbar> -->
            <p-table #exportDataResponse [value]="responseDate" [rows]="15" [paginator]="true" [globalFilterFields]="[
                'AppId',
                'Amount',
                'Status',
                'Remarks',
                'Message',
                ]" responsiveLayout="scroll" [rowHover]="true"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [loading]="loadingExportResponse">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'EXPORT_DATA_RESPONSE'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="exportDataResponse.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="AppId">{{'APP_ID'| translate}}
                            <p-columnFilter type="text" field="AppId" display="menu"></p-columnFilter>
                            <p-sortIcon field="AppId"></p-sortIcon>
                        </th>
                    
                        <th pSortableColumn="Amount">{{'AMOUNT'| translate}}
                            <p-columnFilter type="text" field="Amount" display="menu"></p-columnFilter>
                            <p-sortIcon field="Amount"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Status">{{'STATUS'| translate}}
                            <p-columnFilter type="text" field="Status" display="menu"></p-columnFilter>
                            <p-sortIcon field="Status"></p-sortIcon>
                        </th>
                        
                        <th pSortableColumn="Remarks">{{'REMARKS'| translate}}
                            <p-columnFilter type="text" field="Remarks" display="menu"></p-columnFilter>
                            <p-sortIcon field="Remarks"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Message">{{'MESSAGE'| translate}}
                            <p-columnFilter type="text" field="Message" display="menu"></p-columnFilter>
                            <p-sortIcon field="Message"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-responseData>
                    <tr [ngStyle]="{'color': 'black', 'background-color': responseGridBackgroundColor(responseData)}">
                        <td>{{responseData.AppId}}</td>
                        <td>{{responseData.Amount}}</td>
                        <td>{{responseData.Status}}</td>
                        <td>{{responseData.Remarks}}</td>
                        <td>{{responseData.Message}}</td> 
                    </tr>
                </ng-template>

            </p-table>
        </div>
    </p-card>
</div>